import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { checkRouteAccess } from '@/config/auth/routeAccess';
import { useAccess } from '@/entities/user/providers/useAccess';

/**
 * Per-navigation permission gate (reipm's replacement for gpm's
 * in-AccessProvider route guard — reipm's AccessProvider is router-agnostic).
 *
 * On every location change, evaluates `checkRouteAccess(pathname, user)`
 * against the `routeAccess` table: EVERY rule matching the pathname must pass.
 * Denied → `<Navigate to="/404" replace />` (the legacy monolith's behavior:
 * unauthorized routes look like they don't exist). `/404` itself matches no
 * rule, so the redirect target can never be denied.
 */
export function RouteGuard({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const { user } = useAccess();

  if (!checkRouteAccess(pathname, user)) {
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
